import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { TravelService } from './travel.service';


@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {

  constructor(public auth: TravelService, private router: Router) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const tokenizedReq =  req.clone({setHeaders: {Authorization: `Bearer ${this.auth.getToken()}`}});

    return next.handle(tokenizedReq).pipe(
      catchError(
        (err) => {
          if (err.status === 401) {
            this.handleAuthError();
            return of(err);
          }
          throw err;
        }
      )
    );
  }
  private handleAuthError() {
    localStorage.clear();
    this.router.navigateByUrl('/policy/1');
  }
}
